module.exports = __webpack_public_path__ + "img/Group 427320695@2x.618e0a35.png";